import { createSlice } from "@reduxjs/toolkit";

const initialPosState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  generatedCode: undefined,
  posForEdit: undefined,
  error: null,
  navigate: false,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const posSlice = createSlice({
  name: "pos",
  initialState: initialPosState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      state.navigate = false;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    posFetched: (state, action) => {
      state.actionsLoading = false;
      state.posForEdit = {
        ...action.payload.posForEdit,
      };
      state.error = null;
    },
    posListFetched: (state, action) => {
      const { entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
    },
    posLatestCodeFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.generatedCode = action.payload.generatedCode;
    },
    posCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.navigate = true;
    },
    posUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.navigate = true;
    },

    posDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
  },
});
